module.exports = __webpack_public_path__ + "images/index/img00.b35ecb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/aenatedu/img00.jpg
// module id = HC5y
// module chunks = 21